/**服务中**/
<template>
  <div class="Service">
    <div class="Content">
      <div class="describe">
        <div class="describeContent">
          <h2>{{title}}</h2>
          <h3>{{titleCont}}</h3>
        </div>
        <h4 class="cancelBut" v-if="cancelState" @click="cancelOrderFn">取消订单</h4>
      </div>
      <xk-waiter :src="'../../../../assets/img/yonghu/touxiang.jpg'"
                 :name="DjOrderInfo?DjOrderInfo.employ_name:''"
                 :location="DjOrderInfo?DjOrderInfo.book_address:''"
                 :phone="DjOrderInfo?DjOrderInfo.employ_phone:''"
                 :headImg="DjOrderInfo?DjOrderInfo.employ_head_path:''"
      >
      </xk-waiter>
      <xk-Add :time="DjOrderInfo?DjOrderInfo.book_time:''"
              :origin="DjOrderInfo?DjOrderInfo.book_address:''"
              :endPoint="DjOrderInfo?DjOrderInfo.destination:''">
      </xk-Add>
    </div>
    <xk-input-box v-if="reson.state" title="取消订单理由" @click="cancelOrderFn" :closeState="true">
      <div slot="content" class="DjCancelOrder">
        <textarea maxlength="50" v-model="reson.val" placeholder="请输入取消订单理由">
        </textarea>
      </div>
    </xk-input-box>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
  </div>
</template>

<script>
  import XkWaiter from '../../module/waiter/src/waiter'
  import XkAdd from '../../module/add/src/add.vue'
  import { mapGetters } from 'vuex'
  import XkHintBox from '../../module/hintBox/src/hintBox'
  import XkInputBox from '../../module/inputBox/src/inputBox'

  export default {
    components: {
      XkInputBox,
      XkHintBox,
      XkWaiter,
      XkAdd
    },
    name: '',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        DjOrderInfo: 'DjOrderInfo'
      })
    },
    watch: {
      DjOrderInfo (val) {
        let that = this
        if (this.loginData.passenger && val && this.loginData.passenger.id !== val.passenger_id) {
          this.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
          return
        }
        if (val.status === 10) {
          this.title = (val.gender === '男' ? '服务人员' : '服务人员') + '已接单'
          this.titleCont = '正在向您狂奔...'
          this.cancelState = true
        } else if (val.status === 15) {
          this.title = (val.gender === '男' ? '服务人员' : '服务人员') + '正在前往预约地'
          this.titleCont = '请您耐心等待...'
          this.cancelState = true
        } else if (val.status === 20) {
          this.title = (val.gender === '男' ? '服务人员' : '服务人员') + '已到达预约地'
          this.titleCont = '准备开车啦...'
          this.cancelState = true
        } else if (val.status === 28) {
          this.title = '中途等待...'
          this.titleCont = '中途等待！'
          this.cancelState = false
        } else if (val.status === 25) {
          this.title = '正在前往目的地...'
          this.titleCont = '请系上您的安全带，祝您旅途愉快！'
          this.cancelState = false
        } else if (val.status === 30) {
          this.$router.push({path: '/daijia/settlement', query: {order_id: that.$route.query.order_id}})
          this.cancelState = false
          return false
        } else if (val.status === 35) {
          this.cancelState = false
          this.hintBox = {
            stateShow: true,
            state: 'yes',
            content: '您的订单已完成！'
          }
          setTimeout(() => {
            that.hintBox = false
            that.$router.push({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
          }, 1500)
          return
        } else if (val.status === 45) {
          this.hintBox = {
            stateShow: true,
            state: 'no',
            content: '您的订单已被销单！'
          }
          setTimeout(() => {
            that.hintBox = false
            that.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
          }, 1500)
          return
        }
        console.log('订单状态', val)
      }
    },
    data () {
      return {
        title: '',
        titleCont: '',
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        },
        cancelState: false,
        reson: {
          state: false,
          val: ''
        },
        timer: null // 定时器
      }
    },
    methods: {
      cancelOrderFn: function (val) {
        let that = this
        this.reson.state = !this.reson.state
        if (val === 'affirm') {
          if (this.reson.val !== '') {
            that.loadState = true
            this.$store.dispatch('putCancelOrder', {
              order_id: that.$route.query.order_id,
              remark: this.reson.val,
              fn: (state) => {
                that.loadState = false
                if (state && state.code === 1) {
                  this.reson.state = false
                  that.hintBox = {
                    stateShow: true,
                    state: 'yes',
                    content: '销单成功！'
                  }
                  setTimeout(() => {
                    that.hintBox.stateShow = false
                    that.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
                  }, 1500)
                }
              }
            })
          } else {
            this.reson.state = true
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '请输入销单理由！'
            }
            setTimeout(() => {
              that.hintBox.stateShow = false
            }, 1500)
          }
        }
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
          that.timer = setInterval(function () {
            console.log('订单状态--定时器内部')
            that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
          }, 3000)
        }
      })
    },
    destroyed () {
      if (this.timer) {
        clearInterval(this.timer)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .Service {
    .Content {
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      background-color: #f3f4f5;
      .describe {
        height: 16.666rem;
        background-color: #fff;
        position: relative;
        .describeContent {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        h2 {
          font-size: 2rem;
          color: #333;
          text-align: center;
          margin-top: 1rem;
        }
        h3 {
          color: #999999;
          font-size: 1.25rem;
          text-align: center;
          margin-top: 1.4rem;
        }
        .cancelBut {
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #f06553;
          font-size: 0.8333rem;
          text-align: center;
          height: 24px;
        }
      }
      .Add {
        margin-top: 1rem;
      }
    }
    .DjCancelOrder {
      border: 1px solid #eee;
      height: 10rem;
      textarea {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: none;
        resize: none;
        font-size: 1rem;
        padding: 0.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// service.vue?05e21a42